<template>
  <div class="fb">
    <loader v-show="isLoading"/>
    <div v-if="!isLoading">
      <div class="row top">
        <div class="col header-text">
          <h1>{{ $t('views.feedback.giveUs') }}<span class="blue">{{ $t('views.feedback.feedback') }}</span></h1>
          <h3>{{ $t('views.feedback.leaveUsFeedback') }}</h3>
        </div>
        <div class="col top-block">
        </div>
      </div>

      <div class="container">
        <div class="row">
          <b-alert class="thanks w-100 text-center income-success" :show="showSuccess" variant="success">{{ $t('views.feedback.thankYouFor') }}</b-alert>
          <b-alert class="thanks w-100 text-center" :show="showError" variant="danger">{{ $t('views.feedback.submitFailed') }}</b-alert>
          <div class="col-lg-12" v-show="showForm">
            <div class="row text-center">
              <div class="top-title">{{ $t('views.feedback.feedbackForm') }}</div>
              <div class="w-100">{{ $t('views.feedback.weWouldLove') }}</div>
            </div>
            <div class="row">
              <div class="col-lg-12 feedback-area">
                <div class="feedback-form">
                  <b-form class="feedback-form" @submit="onSubmit" autocomplete="false">
                    <b-form-group
                        id="input-group-text"
                        :label="$t('views.feedback.whatWouldYou')"
                        label-for="textarea-state"
                        description=""
                    >
                      <b-form-textarea
                          id="textarea-state"
                          v-model="form.feedback"
                          placeholder=""
                          name="mauticform[feedback]"
                          rows="6"
                          required
                          trim
                      ></b-form-textarea>
                    </b-form-group>
                    <div class="inline-group">
                      <b-input-group class="mb-2">
                        <div class="w-100">{{ $t('views.feedback.name') }}</div>
                        <b-form-group
                            id="input-fn"
                            label-for="input-1"
                            description="First name"
                            class="w-50"
                        >
                          <b-form-input class="name-field fn"
                                        id="input-first_name"
                                        v-model="form.first_name"
                                        name="mauticform[first_name]"
                                        required
                                        trim
                                        aria-describedby="input-first_name-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-first_name-feedback">{{ $t('views.feedback.enterAtLeast') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group
                            id="input-ln"
                            label-for="input-1"
                            description="Last name"
                            class="w-50"
                        >
                          <b-form-input class="name-field"
                                        id="input-last_name"
                                        v-model="form.last_name"
                                        required
                                        name="mauticform[last_name]"
                                        description="Last name"
                                        trim
                                        aria-describedby="input-last_name-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-last_name-feedback">{{ $t('views.feedback.enterAtLeast1') }}</b-form-invalid-feedback>
                        </b-form-group>
                      </b-input-group>
                    </div>
                    <b-form-group
                        id="input-group-1"
                        :label="$t('views.feedback.emailAddress')"
                        label-for="input-email"
                        description="example@example.com"
                        :aria-placeholder="$t('views.feedback.exampleexamplecom')"
                    >
                      <b-form-input
                          id="input-email"
                          v-model="form.email"
                          name="mauticform[email]"
                          type="email"
                          required
                          :placeholder="$t('views.feedback.enterEmail')"
                      ></b-form-input>
                    </b-form-group>
                    <div class="text-center">
                      <b-button type="submit" class="income-btn " variant="primary">{{ $t('views.feedback.submitFeedback') }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="home-start-investing">
              <h2>{{ $t('views.feedback.startInvestingToday') }}</h2>
              <div class="detail-info">{{ $t('views.feedback.earnUpTo') }}</div>
              <get-started/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import GetStarted from '@/components/GetStartedProd'
import feedback from '@/api/feedback'

export default {
  name: 'Feedback',
  components: {GetStarted, Loader},
  data()
  {
    return {
      form: {
        email: '',
        feedback: '',
        first_name: '',
        last_name: '',
        formId: 3,
        return: '',
        formName: 'feedbackfromhomepage'
      },
      isLoading: false,
      showForm: true,
      showSuccess: false,
      showError: false
    }
  },
  methods: {
    onSubmit(evt)
    {
      evt.preventDefault()
      this.isLoading = true
      this.showError = false
      const data = new URLSearchParams({
        'mauticform[email]': this.form.email,
        'mauticform[feedback]': this.form.feedback,
        'mauticform[first_name]': this.form.first_name,
        'mauticform[last_name]': this.form.last_name,
        'mauticform[formId]': this.form.formId,
        'mauticform[return]': this.form.return,
        'mauticform[formName]': this.form.formName
      })
      // Two-argument then: the rejection handler must only see transport failures.
      // A .catch would also swallow an exception from the success branch and tell
      // the user a delivered submission failed, inviting a duplicate.
      feedback.send(data).then(
          () =>
          {
            this.isLoading = false
            this.showForm = false
            this.showSuccess = true
            window.scrollTo(0, 220) // the banner renders above the long form
          },
          error =>
          {
            console.error('Mautic feedback submit failed', error)
            this.isLoading = false
            this.showError = true
            window.scrollTo(0, 220)
          }
      )
    }
  }
}
</script>

<style scoped lang="scss">

.fb {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.thanks {
  margin-top: 50px;
}

.header-text {
  text-align: center;
  margin: 82px auto 16px 10%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.top-block {
  background-image: url("../assets/lamp-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .top-block {
    display: none;
  }
  .header-text {
    text-align: center;
    margin: 10px auto 16px 0;
  }
}

.top-title {
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 25px;
  width: 100%;
}

.feedback-form {
  margin-top: 25px;
  margin-bottom: 20px;
}

.iframe-fb {
  width: 100%;
  border: none;
  height: 395px;
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .start-investing-img {
    margin-bottom: 40px;
    width: 100%;
    max-width: 590px;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}
.fn {
  width: 96%;
}
.income-success {
  color: #30a7fe;
  background-color: #ffffff;
  border-color: #30A7FE;
  font-weight: bold;
}
</style>
